import { render, staticRenderFns } from "./px-message-bar.vue?vue&type=template&id=3ebf01d5&scoped=true&"
import script from "./px-message-bar.vue?vue&type=script&lang=ts&"
export * from "./px-message-bar.vue?vue&type=script&lang=ts&"
import style0 from "./px-message-bar.vue?vue&type=style&index=0&id=3ebf01d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebf01d5",
  null
  
)

export default component.exports